export const COLLAPSED_DOCUMENTS_COUNT = 2;

export const SHOW_FEWER_LABEL = 'Show fewer';

export const getShowAllLabel = count => `Show all ${count} documents`;

export const getToggleLabel = count => (count === 1 ? '1 document' : `${count} documents`);
